// extracted by mini-css-extract-plugin
export var container = "_cn-0";
export var containerTopRight = "_cn-1";